import './FreelancerMetadata.scss';

import React from 'react';
import PropTypes from 'prop-types';

export default class FreelancerMetadata extends React.Component {
    static propTypes = {
        experienceYears: PropTypes.string.isRequired,
        specializations: PropTypes.string.isRequired
    };

    render() {
        return (
            <div className="c-freelancer-metadata">
                {this.props.specializations ? (
                    <span className="c-freelancer-metadata__posting-location">
                        {this.props.specializations}&nbsp;
                    </span>
                ) : null}

                {this.props.experienceYears ? (
                    <span className="c-freelancer-metadata__posting-duration">
                        | {this.props.experienceYears} yrs. experience
                    </span>
                ) : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Freelancers/components/FreelancerMetadata/index.js